import { MOCK_GATEWAYS } from "../mock/mockGateways";

/**
 * GatewayService — BLE gateway discovery and connection.
 * Swap this singleton for a real BLE adapter when hardware support is available.
 * Real implementation must satisfy the same interface: { getAll, findById }.
 */
export const GatewayService = {
  /** @returns {{ id: string, name: string, rssi: number, hw: string, fw: string, btAddress: string }[]} */
  getAll: () => MOCK_GATEWAYS,

  /** @param {string} id @returns {{ id: string, name: string, rssi: number, hw: string, fw: string, btAddress: string } | null} */
  findById: (id) => MOCK_GATEWAYS.find((g) => g.id === id) ?? null,
};
